import * as React from 'react';
import withStyles from 'react-jss';
import { CssType,
  ThemeType} from '../../theming/jssTypes';
import SearchTagsInput from './SearchSelectTagsInput';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { searchHubWithrealFilter, searchHubDataWithPermission } from '../../api/dashboard';
import { Input, Select, message } from 'src/design-system/components/atoms';
import {
  setCurrHub,
} from '../../actions/cachedDataActions';
import { getSelectStyleForSelectWithInput } from '../../theming/cssSnippets/commonSnippets';
import { trackGaEvents } from 'src/utils/googleAnalyticsHelper';
import { HUB_SEARCH, gaType } from 'src/utils/gaConstants';
import { withTranslation } from 'react-i18next';

const Option = Select.Option;
const styles = (theme: ThemeType): CssType => ({
  selectStyleHubTypeDark : {
    ...getSelectStyleForSelectWithInput({height:'28px', theme}),
    '& .ant-select-selector': {
      borderTopRightRadius: `${theme.radius.none} !important`,
      borderBottomRightRadius: `${theme.radius.none} !important`,
      backgroundColor: `${theme.color.semantic.text.inverse}1A !important`,
      color: `${theme.color.semantic.text.inverse} !important`,
    },
    '&.ant-select-focused .ant-select-selector': {
      backgroundColor: `${theme.color.semantic.text.inverse}1A !important`,
      boxShadow: 'none !important',
    },
    '& .ant-select-arrow': {
      color: `${theme.color.semantic.text.inverse}B3 !important`,
    },
  },
  selectStyleHubTypeLight: {
    ...getSelectStyleForSelectWithInput({ height: '28px', theme }),
    '& .ant-select-selector': {
      borderTopRightRadius: `${theme.radius.none} !important`,
      borderBottomRightRadius: `${theme.radius.none} !important`,
      backgroundColor: `${theme.color.semantic.background.neutral.subtle} !important`,
      color: `${theme.color.semantic.text.primary} !important`,
    },
    '& .ant-select-arrow': {
      color: `${theme.color.semantic.text.primary} !important`,
    },
  },
  selectStyleDark: {
    minWidth: 160,
    maxWidth: 180,
    fontFamily: theme.typography.fontFamily.primary,
    fontSize: theme.typography.fontSize.md,
    '& .ant-select-selector': {
      border: `${theme.border.width.sm} solid ${theme.color.semantic.border.primary}`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '28px !important',
      borderTopRightRadius: `${theme.radius.none} !important`,
      borderBottomRightRadius: `${theme.radius.none} !important`,
      backgroundColor: `${theme.color.semantic.text.inverse}1A !important`,
      color: `${theme.color.semantic.text.inverse} !important`,
      '& .ant-select-selection-item': {
        color: `${theme.color.semantic.text.inverse} !important`,
      },
      '& .ant-select-selection-search-input': {
        color: `${theme.color.semantic.text.inverse} !important`,
      },
    },
    '&:not(.ant-select-disabled):hover .ant-select-selector': {
      backgroundColor: `${theme.color.semantic.text.inverse}1A !important`,
      borderColor: `${theme.color.semantic.border.primary} !important`,
    },
    '&.ant-select-focused .ant-select-selector': {
      backgroundColor: `${theme.color.semantic.text.inverse}1A !important`,
      borderColor: `${theme.color.semantic.border.primary} !important`,
      boxShadow: 'none !important',
      '& .ant-select-selection-item': {
        color: `${theme.color.semantic.text.inverse}B3 !important`,
      },
    },
    '& .ant-select-arrow': {
      color: `${theme.color.semantic.text.inverse} !important`,
    },
  },
  selectStyle: {
    minWidth: 160,
    maxWidth: 180,
    fontFamily: theme.typography.fontFamily.primary,
    fontSize: theme.typography.fontSize.md,
    '& .ant-select-selector': {
      border: `${theme.border.width.sm} solid ${theme.color.semantic.border.primary} !important`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '28px !important',
      borderTopRightRadius: `${theme.radius.none} !important`,
      borderBottomRightRadius: `${theme.radius.none} !important`,
      backgroundColor: `${theme.color.semantic.text.inverse}1A !important`,
    },
    '& .ant-select-arrow': {
      color: theme.color.semantic.text.inverse,
    },
  },
  dropdownMenuClass: {
    '&.ant-select-dropdown': {
      backgroundColor: `${theme.color.semantic.background.neutral.inverse} !important`,
      color: `${theme.color.semantic.text.inverse} !important`,
      border: `${theme.border.width.sm} solid ${theme.color.semantic.background.neutral.inverse} !important`,
      borderTop: 'none !important',
    },
    '& .ant-select-item-option': {
      backgroundColor: `${theme.color.semantic.background.neutral.inverse} !important`,
      color: `${theme.color.semantic.text.inverse} !important`,
    },
    '& .ant-select-item-option:hover': {
      backgroundColor: `${theme.color.semantic.brand.default.primary}4D !important`,
    },
    '& .ant-select-item-empty': {
      backgroundColor: `${theme.color.semantic.background.neutral.inverse} !important`,
      color: `${theme.color.semantic.text.inverse} !important`,
      fontWeight: theme.typography.fontWeight.regular,
      fontSize: theme.typography.fontSize.sm,
      fontFamily: theme.typography.fontFamily.primary,
    },
    '& .ant-select-item-option-content': {
      fontWeight: theme.typography.fontWeight.regular,
      fontSize: theme.typography.fontSize.sm,
      fontFamily: theme.typography.fontFamily.primary,
    }
  },
  lightDropdown: {
  },
});


class HubSearch extends React.PureComponent<any, any> {

  minSearchLength = this.props.minSearchLength || 2;

  state:any = {
    searchedHubs:[],
    tempHubType : this.props.defaultHubType ? this.props.defaultHubType : this.props.hubType,
    selectedHub : null,
  };

  componentDidMount = () => {
    this.setState({
      searchedHubs : this.props.opsHub.extra_hubs ? [] :
                      this.props.opsHub.hub_list.map((hub: any) => ({
                        hub, key: hub.id, label: `${hub.name}, ${hub.code}`,
                      })),
    });
    if (this.props.dontUpdateHub) {
      this.props.onChange && this.props.onChange(this.props.value || this.props.currHub);
      this.setState({ selectedHub: this.props.value || this.props.currHub });
    }
  };

  handleSearchHubChange = (values, options) => {
    const selectedHub = this.state.searchedHubs.filter(x => x.key === values.key)[0];
    trackGaEvents({actionType: HUB_SEARCH}, {values});
    if(!this.props.dontUpdateHub){
      this.props.setCurrHub({ currHub: selectedHub.hub });
    }else{
      this.props.onChange && this.props.onChange(selectedHub.hub);
      this.setState({
        selectedHub : selectedHub.hub,
      });
    }
    this.props.onHubChange && this.props.onHubChange(selectedHub.hub);
    this.props.opsHub.extra_hubs ? this.setState({ searchedHubs: [] }) : null;
  };

  handleSearchedHubsearch = async (queryString: string) => {
    const { tempHubType } = this.state;
    if (!queryString.trim()) {
      this.setState({ searchedhubs: [] });
      return;
    }
    if (queryString.length >= this.minSearchLength) {
      let response;
      if (this.props.withPermission) {
        response =  await searchHubDataWithPermission(queryString);
      } else if (this.props.searchHubData) {
        response = await this.props.searchHubData(queryString);
      } else if (this.props.withType) {
        response = await searchHubWithrealFilter(true)(queryString, tempHubType);
      } else if (this.props.withoutRealFilter) {
        response = await searchHubWithrealFilter(false)(queryString);
      } else {
        response = await searchHubWithrealFilter(true)(queryString);
      }
      if (!response.isSuccess) {
        message.error(response.errorMessage);
        return;
      }
      let searchedHubs = response.data;
      if (this.props.withType) {
        searchedHubs = searchedHubs.filter(x => x.hub_type === this.state.tempHubType);
      }
      searchedHubs = searchedHubs ? searchedHubs.map((hub: any) => ({
        hub, key: hub.id, label: `${hub.name}, ${hub.code}`,
      })) : [],
        this.setState({ searchedHubs });
    }
  };

  generateOptionsFromKeyValue = (optionsList: any) => {
    const x:any = [];
    if (optionsList) {
      optionsList.forEach((ele:any) => {
        x.push(<Option key={ele.key} value = {ele.key}>{ele.val}</Option>);
      });
    }
    return x;
  };
  generateOptionsFromList = (list) => {
    const optionsList: any = [];
    if (list) {
      list.forEach((ele) => {
        optionsList.push(<Option key={ele.id} value={ele.key}>{`${ele.name},${ele.code}`}</Option>);
      });
    }
    return optionsList;
  };
  onHubTypeChange = (value) => {
    this.setState({  tempHubType : value });
    const hubsearchElem: any = document.getElementById('hubSearch');
    if (hubsearchElem) {
      hubsearchElem.click();
    }
  };
  static defaultProps: { propsDropdownClassName: string }; //setting default props as any and making it optional
  render() {
    const { classes, opsHub, currHub, withType, hubType, searchText, placeholder,
      defaultHubType, hubTypeOptions, searchStyle, dontUpdateHub,
      disabled, t, propsDropdownClassName, width, ...otherProps} = this.props;
    const { selectedHub } = this.state;

    return (
      <React.Fragment>
        {withType ? <Select
            {...otherProps}
            onChange={this.onHubTypeChange}
            className={propsDropdownClassName ?
              classes.selectStyleHubTypeLight : classes.selectStyleHubTypeDark}
            defaultValue={defaultHubType ? defaultHubType : hubType}
            disabled={disabled}
            dropdownClassName={propsDropdownClassName ? classes.lightDropdown : classes.dropdownMenuClass}
            style={width ? { minWidth: `${width}px` } : {}}
            >
              {this.generateOptionsFromKeyValue(hubTypeOptions)}
          </Select> : null}
        {opsHub.extra_hubs ?  <SearchTagsInput
            {...otherProps}
            id = "hubSearch"
            inputRef = {this.props.inputRef}
            labelInValue
            size={'default'}
            allowClear={false}
            classname={classes.searchBar}
            dropdownClassName={propsDropdownClassName ? classes.lightDropdown : classes.dropdownMenuClass}
            placeholder={placeholder ? placeholder : 'Select Hub'}
            value={!selectedHub ? {
              key: currHub.id,
              value: currHub.id,
              label: `${currHub.name}, ${currHub.code}`,
            }: {
              key: selectedHub.id,
              label: `${selectedHub.name}, ${selectedHub.code}`,
              value: selectedHub.id,
            }}
            thresholdLength={this.minSearchLength}
            searchText={searchText ? searchText : t('search_for_hubs')}
            options={this.state.searchedHubs}
            onChange={this.handleSearchHubChange}
            searchFunction={this.handleSearchedHubsearch}
            className={searchStyle || (propsDropdownClassName ? classes.selectStyle : classes.selectStyleDark)}
            disabled={disabled}
            style={width ? { minWidth: `${width}px` } : {}}
          /> :

          <Select
            {...otherProps}
            id = "hubSearch"
            showSearch
            labelInValue
            placeholder={placeholder ? placeholder : 'Select Hub'}
            optionFilterProp="children"
            className={propsDropdownClassName ? classes.selectStyle : classes.selectStyleDark}
            dropdownClassName={propsDropdownClassName ? classes.lightDropdown : classes.dropdownMenuClass}
            value={!selectedHub ? {
              key: currHub.id,
              label: `${currHub.name}, ${currHub.code}`,
            } : {
              key: selectedHub.id,
              label: `${selectedHub.name}, ${selectedHub.code}`,
            }}
            onChange={this.handleSearchHubChange}
            filterOption={(input, option: any) =>
               option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            disabled={disabled}
            style={width ? { minWidth: `${width}px` } : {}}
          >
            {this.generateOptionsFromList(withType ?
            this.props.opsHub.hub_list.filter(hub => hub.hub_type === this.state.tempHubType) :
            this.props.opsHub.hub_list,
            )}
          </Select>
        }
      </React.Fragment>
    );
  }
}

const HubSearchStyled = withStyles(styles, { injectTheme: true })(HubSearch);

const mapStateToProps = ({ masterData, cachedData }, ownProps) => {
  return {
    hubTypeOptions : ownProps.hubTypeOptions ? ownProps.hubTypeOptions :  [
            { key:'dc', val: ownProps.t('planning_hub') },
            { key:'upcountry', val: ownProps.t('upcountry_hub')  },
    ],
    currHub: cachedData.currHub,
    hubType : cachedData.hubType,
    opsHub: masterData.ops_hub,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    setCurrHub,
  }, dispatch);
};

HubSearch.defaultProps = {
  propsDropdownClassName: undefined, // Setting the default value of propsDropdownClassName to undefined
};

export default  withTranslation('translation')
      (connect(mapStateToProps, mapDispatchToProps)(HubSearchStyled));

